import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plussquareo",
  "use": "plussquareo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"plussquareo\"><title>plussquareo</title><path d=\"M13.875 2.125v11.766H2.125V2.125h11.75zm0-1.125H2.125q-.469 0-.797.328T1 2.125v11.766q0 .453.328.789t.797.336h11.766q.453 0 .789-.336t.336-.789V2.125q0-.469-.336-.797T13.875 1zm-2.437 6.438H8.563V4.579q0-.234-.164-.398t-.398-.164q-.219 0-.391.164t-.172.398v2.859H4.563q-.234 0-.398.172t-.164.391q0 .234.164.398t.398.164h2.875v2.859q0 .234.172.398t.391.164q.234 0 .398-.164t.164-.398V8.563h2.875q.234 0 .398-.164T12 8.001q0-.219-.164-.391t-.398-.172z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/plussquareo.svg
// module id = 525
// module chunks = 0